import all from '../all'
import ecommerce from './ecommerce'
import newUserProfile from './new-user-profile'
import newCompanyProfile from './new-company-profile'

const bmve = {
  ...all,
  ecommerce,
  newUserProfile,
  newCompanyProfile,
}

export default bmve
